import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountTransactionActions from "../actions/account_transactions_actions";
import * as globalTransactionActions from "../actions/global_transactions_actions";

import * as accountTransactionsTypes from "../types/account_transactions_types";
import * as globalTransactionsTypes from "../types/global_transactions_types";

import { dispatchSnackbarError } from "../../../../utils/toaster";

const endpoints = {
    ACCOUNT_TRANSACTIONS: "/user-service/api/super-admin/campaign/wallet/history/global/transactions",
    ACCOUNT_IMP_TRANSACTIONS: "/user-service/api/super-admin/campaign/wallet/history/global/imp-transactions",
    ACCOUNT_SUMMARY: "/user-service/api/super-admin/campaign/wallet/history/global/summary",
    GLOBAL_TRANSACTIONS: "/user-service/api/super-admin/campaign/wallet/history/global/transactions",
    GLOBAL_IMP_TRANSACTIONS: "/user-service/api/super-admin/campaign/wallet/history/global/imp-transactions",
    GLOBAL_SUMMARY: "/user-service/api/super-admin/campaign/wallet/history/global/summary",
};

function* getAccountTransactions(action) {
    try {
        const res = yield call(api.get, endpoints.ACCOUNT_TRANSACTIONS, action.payload);
        if (res.status === 200) {
            yield put(accountTransactionActions.getAccountTransactionsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountTransactionActions.getAccountTransactionsError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountTransactionActions.getAccountTransactionsError(e));
    }
}
function* getAccountImpTransactions(action) {
    try {
        const res = yield call(api.get, endpoints.ACCOUNT_IMP_TRANSACTIONS, action.payload);
        if (res.status === 200) {
            yield put(accountTransactionActions.getAccountImpTransactionsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountTransactionActions.getAccountImpTransactionsError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountTransactionActions.getAccountImpTransactionsError(e));
    }
}
function* getAccountTransactionSummary(action) {
    try {
        const res = yield call(api.get, endpoints.ACCOUNT_SUMMARY, action.payload);
        if (res.status === 200) {
            yield put(accountTransactionActions.getAccountTransactionSummarySuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(accountTransactionActions.getAccountTransactionSummaryError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(accountTransactionActions.getAccountTransactionSummaryError(e));
    }
}

function* getGlobalTransactions(action) {
    try {
        const res = yield call(api.get, endpoints.GLOBAL_TRANSACTIONS, action.payload);
        if (res.status === 200) {
            yield put(globalTransactionActions.getGlobalTransactionsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(globalTransactionActions.getGlobalTransactionsError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(globalTransactionActions.getGlobalTransactionsError(e));
    }
}
function* getGlobalImpTransactions(action) {
    try {
        const res = yield call(api.get, endpoints.GLOBAL_IMP_TRANSACTIONS, action.payload);
        if (res.status === 200) {
            yield put(globalTransactionActions.getGlobalImpTransactionsSuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(globalTransactionActions.getGlobalImpTransactionsError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(globalTransactionActions.getGlobalImpTransactionsError(e));
    }
}
function* getGlobalTransactionSummary(action) {
    try {
        const res = yield call(api.get, endpoints.GLOBAL_SUMMARY, action.payload);
        if (res.status === 200) {
            yield put(globalTransactionActions.getGlobalTransactionSummarySuccess(res.data));
        } else {
            dispatchSnackbarError(res.data.message);
            yield put(globalTransactionActions.getGlobalTransactionSummaryError(res.data));
        }
        if (action.cb) action.cb(res.data);
    } catch (e) {
        yield put(globalTransactionActions.getGlobalTransactionSummaryError(e));
    }
}

export default function* campaignDetailsSaga() {
    yield takeLatest(accountTransactionsTypes.getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_REQUEST, getAccountTransactions);
    yield takeLatest(accountTransactionsTypes.getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_REQUEST, getAccountImpTransactions);
    yield takeLatest(accountTransactionsTypes.getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_REQUEST, getAccountTransactionSummary);
    yield takeLatest(globalTransactionsTypes.getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_REQUEST, getGlobalTransactions);
    yield takeLatest(globalTransactionsTypes.getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_REQUEST, getGlobalImpTransactions);
    yield takeLatest(globalTransactionsTypes.getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_REQUEST, getGlobalTransactionSummary);

}
